import templateBase from './templates/account-menu.html';
import templateT10 from './templates/account-menu-t10.html';
import templateT11 from './templates/account-menu-t11.html';


function accountMenuDirective(SessionService) {

  let response = SessionService.get('components');
  let htmlTemplate = templateBase;
  try {
    if (
      response.MY_ACCOUNT.component == 'template_t10') {
      htmlTemplate = templateT10;
    } else if (
      response.MY_ACCOUNT.component == 'template_t11') {
      htmlTemplate = templateT11;
    }
  } catch (e) {
  }

  return {
    restrict: 'E',
    template: htmlTemplate,
  };
}

accountMenuDirective.$inject = ['SessionService'];


export default accountMenuDirective;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/header-core/account-menu/account-menu.directive.js
 **/